<template>
    <!-- Menu -->
    <div class="fixed-top " id="menutop">
        <!-- Contenedor navegación -->
        <div class="contenedor_navegacion" id="navbartoggler">
            <div class="navegacion">

                <!-- Contenido Izquierdo -->
                <!-- Logo Chevron Card -->
                <a class="logo_img">
                    <img class="" src="../img/Recurso 53.png">
                    <!-- <img  class="img-top img-fluid mobilLogo scroll"  src="vistas/dist/custom/imgs/mayos_white.png"> -->
                </a>
                <!-- <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarmenu"
                    aria-controls="navbarmenu" aria-expanded="false" aria-label="Toggle navigation"
                    style="outline: none;">
                </button> -->
                </div>
                <div class="navegacion">
                <!-- Contenido Derecho -->
                <div class="contenido_grupo" id="navbarmenu">
                    <div class="contenedor_acceso">
                        <!-- Registro -->
                        <div class="nav-item elemento_nav">
                            <router-link class="item_menu_log" :to="{name: 'index'}">
                                <i class="fa-solid fa-user-plus"></i>
                                <span class="texto_menu">Registro</span>
                            </router-link> 
                        </div>
                        <!-- Iniciar Sesión -->
                        <div class="nav-item elemento_nav">
                            <router-link class="item_menu_log" :to="{name: 'loginV'}">
                                <i class="fa-solid fa-right-to-bracket"></i>
                                <span class="texto_menu">Iniciar Sesión</span>
                            </router-link>
                        </div>
                    </div>

                        <!-- Redes Sociales -->
                    <div class="contenedor_elementos">
                        <a href="https://www.facebook.com/GrupoHorizon/" class="elemento_nav seccion" target="_blank"><i
                             class="fab fa-facebook iconColor"></i></a>
                        <a href="https://www.instagram.com/grupohorizon.mx/" class="elemento_nav seccion" target="_blank"><i
                            class="fab fa-instagram iconColor"></i></a>
                    </div>
                        
                        <!-- <li class="nav-item mobilMenu w-100 align-items-start" style="border-top: 1px solid #c2c2c2;">
                            <a class="nav-link mr-2 " href="#"
                                style="font-size: 9px;border-bottom: 0px solid transparent;" target="_blank">CHEVRONCARD
                                2024</a>

                        </li> -->
                </div>
            </div>
        </div>
    </div>

</template>

<script>

export default {
    methods:
    {
        sbLogin() {
            this.$router.push('/login');
        }
    }

}
</script>

<style scoped>
.contenedor_navegacion{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin: 0;
    background: linear-gradient(100deg, #0752ab,#4aceea,#0a47a6);
    border-bottom: none;
    box-shadow: 0 2px 10px rgba(0,0,0,.08);
    padding: 0 60px;
}

.navegacion{
    display: flex;
    flex-direction: row;
}
.logo_img {
    display: flex;
    align-items: center;
}
.logo_img img{
    width: 200px;
    height: 40px;
}

.contenido_grupo{
    display: flex;
    flex-direction: row;
    gap: 20px;
}
.alinear_derecha,
.contenedor_acceso{
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 20px;
}

.alinear_derecha{
    flex-direction: row;
    margin: 0;
}

.contenedor_acceso{
    gap: 10px;
}

.nav-link{
    text-transform: uppercase;
    font-weight: 700 !important;
}

/* linea abajo a arriba */
.item_menu_log{
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 15px;
    padding: 8px 10px;
    font-size: 16px;
    cursor: pointer;
    position: relative;
    border-radius: 10px;
    transition: .25s ease;
    color: #fff;
    text-decoration: none;
    overflow: hidden;
    font-weight: 700;
    text-transform: uppercase;
    white-space: nowrap;
}

.item_menu_log i{
    font-size: 16px;
    transition: 0.25s;
}

.item_menu_log::before{
    content: "";
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 3px;
    border-radius: 0px;
    background-color: #fff;
    transform: scaleX(0);
    transform-origin: left;
    transition: .25s ease;
}

.item_menu_log:hover::before{
    color: #fff;
    background-color: rgba(255,255,255,0.8);
    transform: translateX(-1px);
}

@media (max-width: 850px){
    .item_menu_log{
        font-size: 15px;
    }

    /* .logo_img img{
        width: 180px;
        height: 40px;
    } */
    .contenedor_navegacion{
        padding: 0 10px;
    }

     .texto_menu{
        display: none;
    }

    .item_menu_log{
        width: 35px;
        height: 35px;
        padding: 0;
        font-size: 14px;
        border-radius: 50%;
        background: rgba(255,255,255,.08);
    }

    .item_menu_log i{
        font-size: 14px;
    }

    .item_menu_log::before{
        display: none;
    }

    .item_menu_log:hover{
        /* transform: scale(1.1); */
        background: rgba(255,255,255,.16);
    }

    .contenedor_acceso{
        gap: 5px;
    }

    .contenido_grupo{
        gap: 10px;
    }

    .logo_img img {
        width: 160px;
        height: 30px;
    }
}
</style>